// src/pages/buyers/styles.js
import { styled, alpha, Card, Paper, Chip } from '@mui/material';

// ============================================
// BRAND COLORS
// ============================================

export const BRAND_COLORS = {
  primary: '#2E7D32',
  primaryLight: '#4CAF50',
  primaryDark: '#1B5E20',
  primaryLightest: '#E8F5E9',
  secondary: '#C62828',
  secondaryLight: '#EF5350',
  accent: '#FF6F00',
  accentLight: '#FFA726',
  background: '#F0F2F5',
  surface: '#FFFFFF',
  text: '#1A1A1A',
  textSecondary: '#6B7280',
  border: '#E5E7EB',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',
  whatsapp: '#25D366',
};

// ============================================
// STYLED COMPONENTS
// ============================================

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  transition: 'all 0.2s ease-in-out',
  border: '1px solid #E5E7EB',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    borderColor: BRAND_COLORS.primary,
  },
}));

export const ProductCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  transition: 'all 0.3s ease-in-out',
  border: '1px solid #E5E7EB',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    borderColor: BRAND_COLORS.primary,
  },
}));

export const StatCard = styled(Paper)(({ theme }) => ({
  padding: 20,
  borderRadius: 12,
  border: '1px solid #E5E7EB',
  background: '#FFFFFF',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  },
}));

export const StatusChip = styled(Chip)(({ label, theme }) => {
  const statusMap = {
    'Pending': { bg: alpha(BRAND_COLORS.warning, 0.12), color: BRAND_COLORS.warning },
    'Processing': { bg: alpha(BRAND_COLORS.info, 0.12), color: BRAND_COLORS.info },
    'Shipped': { bg: alpha(BRAND_COLORS.info, 0.12), color: BRAND_COLORS.info },
    'Delivered': { bg: alpha(BRAND_COLORS.success, 0.12), color: BRAND_COLORS.success },
    'Cancelled': { bg: alpha(BRAND_COLORS.error, 0.12), color: BRAND_COLORS.error },
    'Paid': { bg: alpha(BRAND_COLORS.success, 0.12), color: BRAND_COLORS.success },
    'Failed': { bg: alpha(BRAND_COLORS.error, 0.12), color: BRAND_COLORS.error },
    'Active': { bg: alpha(BRAND_COLORS.success, 0.12), color: BRAND_COLORS.success },
    'Inactive': { bg: alpha(BRAND_COLORS.error, 0.12), color: BRAND_COLORS.error },
  };
  const styles = statusMap[label] || { bg: alpha(BRAND_COLORS.textSecondary, 0.1), color: BRAND_COLORS.textSecondary };

  return {
    borderRadius: 20,
    fontWeight: 600,
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    backgroundColor: styles.bg,
    color: styles.color,
    height: 24,
    '& .MuiChip-label': {
      padding: '0 10px',
    },
  };
});